export default __webpack_public_path__ + "static/media/Services-2.04689a37.jpg";